import { render, staticRenderFns } from "./templateEventCalendar.vue?vue&type=template&id=982c0b7c&scoped=true"
import script from "./templateEventCalendar.vue?vue&type=script&lang=js"
export * from "./templateEventCalendar.vue?vue&type=script&lang=js"
import style0 from "./templateEventCalendar.vue?vue&type=style&index=0&id=982c0b7c&prod&scoped=true&lang=scss"
import style1 from "./templateEventCalendar.vue?vue&type=style&index=1&id=982c0b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982c0b7c",
  null
  
)

export default component.exports